// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3_GYv"};